module.exports = __webpack_public_path__ + "static/media/Quality.5b759567.jpg";